var map = {
	"./template.bet575": 1869,
	"./template.bet575.tsx": 1869,
	"./template.bet777": 1870,
	"./template.bet777.tsx": 1870,
	"./template.betgalaxy": 1871,
	"./template.betgalaxy.tsx": 1871,
	"./template.betprofessor": 2051,
	"./template.betprofessor.tsx": 2051,
	"./template.betroyale": 1872,
	"./template.betroyale.tsx": 1872,
	"./template.betstride": 1873,
	"./template.betstride.tsx": 1873,
	"./template.buffalobet": 1874,
	"./template.buffalobet.tsx": 1874,
	"./template.chromabet": 1875,
	"./template.chromabet.tsx": 1875,
	"./template.default": 707,
	"./template.default.tsx": 707,
	"./template.epicodds": 1876,
	"./template.epicodds.tsx": 1876,
	"./template.fiestabet": 2005,
	"./template.fiestabet.tsx": 2005,
	"./template.gigabet": 1877,
	"./template.gigabet.tsx": 1877,
	"./template.goldenbet888": 1878,
	"./template.goldenbet888.tsx": 1878,
	"./template.goldenrush": 1879,
	"./template.goldenrush.tsx": 1879,
	"./template.hyperbet": 1880,
	"./template.hyperbet.tsx": 1880,
	"./template.juicybet": 2006,
	"./template.juicybet.tsx": 2006,
	"./template.junglebet": 2007,
	"./template.junglebet.tsx": 2007,
	"./template.magnumbet": 1881,
	"./template.magnumbet.tsx": 1881,
	"./template.oldgill": 1882,
	"./template.oldgill.tsx": 1882,
	"./template.puntcity": 1883,
	"./template.puntcity.tsx": 1883,
	"./template.puntgenie": 1884,
	"./template.puntgenie.tsx": 1884,
	"./template.pyramidbet": 1885,
	"./template.pyramidbet.tsx": 1885,
	"./template.questbet": 1886,
	"./template.questbet.tsx": 1886,
	"./template.slambet": 1887,
	"./template.slambet.tsx": 1887,
	"./template.sterlingparker": 1888,
	"./template.sterlingparker.tsx": 1888,
	"./template.sugarcastle": 2052,
	"./template.sugarcastle.tsx": 2052,
	"./template.templebet": 1889,
	"./template.templebet.tsx": 1889,
	"./template.titanbet": 1890,
	"./template.titanbet.tsx": 1890,
	"./template.ts": 995,
	"./template.vikingbet": 1891,
	"./template.vikingbet.tsx": 1891,
	"./template.volcanobet": 1892,
	"./template.volcanobet.tsx": 1892,
	"./template.wellbet": 1893,
	"./template.wellbet.tsx": 1893
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2792;